module.exports = __webpack_public_path__ + "static/landing-pages-b97986d7b6ae6d0dc78dc195fb1c6228.jpg";